import React from 'react';
import { Avatar } from 'components';

import {
  Container,
  FullProfileName,
  InfoContainer,
  NameContainer,
  ProfileSkeleton,
} from './common';
import { ContactDrawerTeam } from '../../types';

interface TeamProfileProps {
  isLoading: boolean;
  teamContact: ContactDrawerTeam;
}

const TeamProfile: React.FC<TeamProfileProps> = ({
  isLoading,
  teamContact,
}) => {
  if (isLoading || !teamContact) {
    return ProfileSkeleton;
  }
  return (
    <Container>
      <InfoContainer>
        <Avatar defaultType="people" defaultColor="gray7" width={36} />
        <NameContainer>
          <FullProfileName level={2}>{teamContact.name}</FullProfileName>
        </NameContainer>
      </InfoContainer>
    </Container>
  );
};

export default TeamProfile;
